import { render, staticRenderFns } from "./TableHead.vue?vue&type=template&id=4b1531d1&"
import script from "./TableHead.vue?vue&type=script&lang=ts&"
export * from "./TableHead.vue?vue&type=script&lang=ts&"
import style0 from "./TableHead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports